module.exports = __webpack_public_path__ + "assets/img/麦铂精酿.cfbc555f.png";